import React, { Component } from 'react';
import $ from "jquery";

export default class CajaMusica extends Component {
    state={
        isStarted: false,
        loading:true,
    }
    audio = new Audio();

    componentDidMount(){
        var self=this;
        //Loading Audio
        self.audio.src=this.props.musicPath;
        $(self.audio).on('loadedmetadata', function(){
            self.setState({loading: false});
            $('#fill'+self.props.musicUUID).attr({'max': self.audio.duration, 'value': 0});
            audioFunctions(self);
        });

        //Audio Functions
        function audioFunctions(self){
            var totalTime;
            function VerifyTime(time){
                if(time<10){
                    return "0"+time;
                }
                else{
                    return time;
                }
            }
            let TotalMinutes=Math.floor(self.audio.duration)/60;
            let TotalSeconds=Math.floor(self.audio.duration)%60;
            totalTime=VerifyTime(Math.floor(TotalMinutes))+":"+VerifyTime(TotalSeconds);
            $('#timeB'+self.props.musicUUID).html(totalTime);

            $('#PlayMusic'+self.props.musicUUID).click(function PlayMusic(){
                if(!self.state.isStarted){
                    self.setState({isStarted: true});
    
                    $('#MusicStateIcon'+self.props.musicUUID).html('pause');
                    self.audio.play();
                    self.props.stopOtherSounds(self.props.musicUUID); //+
                }else{
                    if(!self.audio.paused){
                        self.audio.pause();
                        $('#MusicStateIcon'+self.props.musicUUID).html('play_arrow');
                    }
                    else{
                        self.audio.play();
                        $('#MusicStateIcon'+self.props.musicUUID).html('pause');
                        self.props.stopOtherSounds(self.props.musicUUID); //+
                    }
                }
            });
            $(self.audio).on('timeupdate', function(){
                if(self.audio){
                    var position=(self.audio.currentTime/self.audio.duration)*100;
                    $('#fill'+self.props.musicUUID).val(self.audio.currentTime).css('background', 'linear-gradient(90deg, var(--default-color-hover) '+position+'%, #b3b0b0 '+(position+0.1)+'%)');
                    
                    let Minutes=Math.floor(self.audio.currentTime)/60;
                    let Seconds=Math.floor(self.audio.currentTime)%60;
                    $('#timeA'+self.props.musicUUID).text(VerifyTime(Math.floor(Minutes))+":"+VerifyTime(Seconds));
                }
            });
            $(self.audio).on('ended', function(){
                $('#MusicStateIcon'+self.props.musicUUID).html('play_arrow');
                $('#timeA'+self.props.musicUUID).html("00:00");
                self.audio.currentTime=0;
            });
            $('#fill'+self.props.musicUUID).on('change input', function(){
                self.audio.currentTime=this.value;
            });

            $("#musicDelete"+self.props.musicUUID).on('click', function(){
                $('#DelScreen'+self.props.musicUUID).css("display", "flex");
                $('#DelScreen'+self.props.musicUUID).animate({opacity: 1}, 300);
            });
            $("#Cancel"+self.props.musicUUID).on('click',function(){
                $('#DelScreen'+self.props.musicUUID).animate({opacity: 0}, 300, function(){
                    $('#DelScreen'+self.props.musicUUID).css("display", "none");
                });
            });
        
            $("#DeleteImage"+self.props.musicUUID).on('click',function(){
                $('#DelScreen'+self.props.musicUUID).animate({opacity: 0}, 300, function(){
                    $('#DelScreen'+self.props.musicUUID).css("display", "none");
                    $('.ContenidoPaginaUser').css("paddingRight", '40px');
                });
                $('#D'+self.props.musicUUID).animate({opacity: 0}, 300, function(){
                    $('#D'+self.props.musicUUID).css("display", "none");
                    $('body').css("overflow-y", "auto");
                });
            });
        }
    }

    componentDidUpdate(previousProps){ //++++++++++++
        if(previousProps.pauseSwitch !== this.props.pauseSwitch){
            if(!this.audio.paused){
                this.audio.pause();
                this.audio.currentTime = 0;
                $('#MusicStateIcon'+this.props.musicUUID).html('play_arrow');
            }
        }
    }

    componentWillUnmount(){
        this.audio.pause();
    }

    render() {        
        var dataLoader=<div className="LoadingContainer GradientLoader">
            <div className="loader"></div>    
        </div>
        return (
            <div className="CajaMusica">
                {
                this.state.loading ? dataLoader : <React.Fragment>
                    <div className="MusicData">
                        <h4 className="MusicTitle">{this.props.title}</h4>
                    </div>
                    <div className="Player">
                        <div className="MusicOptions">
                            <div className="Pause" id={'PlayMusic'+this.props.musicUUID}><i id={'MusicStateIcon'+this.props.musicUUID} className="material-icons-round">play_arrow</i></div>
                            <i id={'musicDelete'+this.props.musicUUID} className="material-icons-round PlayerDelete">delete</i>
                        </div>
                        <div className="MusicRange">
                            <p className="time" id={'timeA'+this.props.musicUUID}>00:00</p>
                            <input type="range" className="fill" id={'fill'+this.props.musicUUID} step="any"/>
                            <p className="time" id={'timeB'+this.props.musicUUID}>00:00</p>
                        </div>
                    </div>
                    <div className="deleteConfirm" id={'DelScreen'+this.props.musicUUID}>
                        <div className="card">
                            <div className="body-card" style={{padding: "45px"}}>
                            <div className="info-card">
                                <h1>¿Borrar música?</h1>
                                <p>Cuidado, sí das click en "aceptar", la música seleccionada se borrara de forma permanente.</p>
                            </div>
                            <div className="buttons-card">
                                <button className="btn" id={'Cancel'+this.props.musicUUID}><i className="material-icons-round">clear</i>Cencelar</button>
                                <button className="btn" id={'DeleteImage'+this.props.musicUUID} onClick={() => this.props.onDelete(this.props.index)}>
                                <i className="material-icons-round">done</i>Aceptar
                                </button>
                            </div>
                            </div>
                        </div>
                  </div>
                </React.Fragment>
                }
            </div>
        )
    }
}